import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  warning: {
    alignItems: 'center',
    color: theme.colorPalette.green_20,
    fontSize: 16,
    lineHeight: 1.4
  },
  button: {
    backgroundColor: theme.colorPalette.green_30,
    color: theme.colorPalette.white_10,
    fontSize: 16,
    width: 150
  }
});

export default makeStyles(styles);
